const realm = "CH";

export default Object.freeze({
    realm
});
